<template>
    <div class="content">
        <div class="navbar">
            <div class="navbar-back" @click="goBack()">
                <i class="icon-back">&lt;</i> 
            </div>
            <div class="navbar-title">
                {{ title }}
            </div>
        </div>

        <div v-for="(item, index) in getLists" @click="goDetail(item)" :key="index">
            <div style="height: 20px;" />
            <div class="item">
                <div class="item_bew">
                    <div style="margin-top: 5px;">
                        状态：
                    </div>
                    <div>
                        <el-tag size="mini">{{ getStatus(item.status) }}</el-tag>
                    </div>
                </div>
                <div style="height: 1px;background-color: #f2f2f2;width: 100%;margin: 10px 0px;"></div>
                <div class="item_bew">
                    <div>
                        姓名：
                    </div>
                    <div>
                        {{ item.name }}
                    </div>
                </div>
                <div class="item_bew">
                    <div>
                        身份证号：
                    </div>
                    <div>
                        {{ item.cardId }}
                    </div>
                </div>
                <div class="item_bew">
                    <div>
                        手机号：
                    </div>
                    <div>
                        {{ item.cell }}
                    </div>
                </div>
                <div class="item_bew">
                    <div>
                        创建时间：
                    </div>
                    <div>
                        {{ item.createTime }}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { Toast, Loading } from 'vant'
export default {
    data() {
        return {
            getLists: [],
            title: '报告列表'
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        getStatus(val) {
            if (val == 0) {
                return '待生成'
            } else if (val == 1) {
                return '已生成'
            } else if (val == 2) {
                return '生成失败'
            }
        },
        goDetail(val) {
            if (val.status == 1) {
                this.$router.push(`/PdfInfo?id=${val.id}`);
                // this.$router.push({ name: 'PdfInfo', query: val.id });
            } else {
                Toast('报告未生成');
            }
        },
        getList() {
            this.$axios.get(`/order/list?pageNum=1&pageSize=100`, {}).then(res => {
                if (res.code == 200) {
                    this.getLists = res.rows
                    console.log(this.getLists, "this.getLists");
                }
            })
        }
    }
}
</script>

<style scoped>
.content {
    min-height: 100%;
    background-color: #f2f2f2;
}

.item_bew {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    line-height: 10px;
    font-style: normal;
    text-transform: none;
    background: none;
}
.navbar {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background-color: #f8f8f8;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.navbar-back {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #007aff;
  margin-right: 16px;
}

.navbar-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.icon-back {
  font-size: 24px;
  margin-right: 8px;
}
.item {
    padding: 10px;
    margin: 0px auto;
    width: 330px;
    height: 130px;
    background-color: #ffff;
    border-radius: 10px;
}
</style>
